import React, { useContext, useEffect, useState } from 'react'
import ButtonWithIcon from "../ButtonWithIcon/ButtonWithIcon"
import SvgClose from "../../public/assets/icons/close.svg"
import calendarBooking from "../../public/assets/icons/calendarbooking.svg"
import styles from "./BookingForm.module.scss";
import { useForm } from 'react-hook-form';
import Calendar from '../Calendar/Calendar';
import AccessForm from '../AccessForm/AccessForm';
import { checkCookies, getCookie } from 'cookies-next';
import MyInformationBooking from '../MyInformationBooking/MyInformationBooking';
import { ApplicationContext } from '../../context/ApplicationContext';
import ConfirmationBooking from '../ConfirmationBooking/ConfirmationBooking';
import AcceptLoyalty from '../AccessLoyalty/AccessLoyalty';
import Swal from 'sweetalert2';
import ReactDOMServer from "react-dom/server";
import CloseIcon from "../../public/assets/icons/closeIcon.svg";
import en from '../../public/langs/strings_en'
import it from '../../public/langs/strings_it.js';
import fr from '../../public/langs/strings_fr.js';
import ru from '../../public/langs/strings_ru.js';
import ch from '../../public/langs/strings_ch.js';
import ja from '../../public/langs/strings_ja.js';
import ko from '../../public/langs/strings_ko.js';
import { useRouter } from 'next/router';




const BookingForm = ({ properties, bookingDays, disableDate, dataContent, brandName, bookableBrand, lang, brandId, app, apptoken, slotLen }) => {
    const { setShowLoader } = useContext(ApplicationContext);
    const [openedBooking, setOpenedBooking] = useState(false);
    const [optionLang, setOptionLang] = useState(lang);
    const { control, register } = useForm();
    const router = useRouter()

    const [step, setStep] = useState(0);
    const [date, setDate] = useState();
    const [bookingTime, setBookingTime] = useState();
    const [phone, setPhone] = useState();
    const [stepTitle, setStepTitle] = useState(dataContent.step1.title);
    const [formData, setFormData] = useState();
    const [message, setMessage] = useState('');
    const [booked, setBooked] = useState(false);
    const [loyalty, setLoyalty] = useState(false);
    const [language, setLanguage] = useState();
    const [dataLang, setDataLang] = useState();
    const [contact, setContact] = useState();
    const [type, setType] = useState();
    const [categories, setCategories] = useState();
    const [errorTimeCheck, setErrorTimeCheck] = useState();
    const [errorLanguage, setErrorLanguage] = useState();
    const [errorType, setErrorType] = useState();
    const [errorContact, setErrorContact] = useState();
    const [errorPhone, setErrorPhone] = useState();


    const loyaltyCookie = checkCookies("myarea") && JSON.parse(getCookie("myarea"))?.loyalty;
    const access = JSON.stringify(getCookie("myarea"));




    useEffect(() => {
        if ((!loyaltyCookie) && access) {
            Swal.fire({
                title: properties.MESSAGE_BA_LOYALTY_KO,
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                closeButtonHtml: ReactDOMServer.renderToString(<CloseIcon />),
            });
        }
    }, [loyaltyCookie, access, properties])


    useEffect(() => {
        const booking = JSON.parse(localStorage.getItem('BOOKING'));
        if (booking) {
            setOpenedBooking(true)
        }
        if (getCookie("myarea")) {
            if (JSON.parse(getCookie("myarea")).access_token) {
                init();
            }
        }
        if (apptoken) {
            init()
        }
    }, []);

    useEffect(() => {
        switch (lang) {
            case 'en':
                setOptionLang(en)
                setDataLang('en-EN')
                break;
            case 'it':
                setOptionLang(it)
                setDataLang('it-IT')
                break;
            case 'fr':
                setOptionLang(fr)
                setDataLang('fr-FR')
                break;
            case 'ru':
                setOptionLang(ru)
                setDataLang('ru-RU')
                break;
            case 'zh':
                setOptionLang(ch)
                setDataLang('zh-Hans-CN')
                break;
            case 'jp':
                setOptionLang(ja)
                setDataLang('ja-JP-u-ca-japanese')
                break;
            case 'kr':
                setOptionLang(ko)
                setDataLang('ko-KR')
                break;
            default:
        }
    }, [])


    const init = async (token = null) => {
        setShowLoader(true);
        let res;
        let resApp;
        if (!apptoken) {
            res = await fetch(
                `${process.env.NEXT_PUBLIC_FE_CUSTOMER}` +
                JSON.parse(getCookie("myarea")).access_token
            );
        } else {
            resApp = await fetch(
                `${process.env.NEXT_PUBLIC_FE_CUSTOMER}` + apptoken
            );
        }

        const resjs = !apptoken ? await res.json() : await resApp.json();

        setShowLoader(false);

        if (resjs?.result == false) {
            Swal.fire({
                title: properties[resjs.message],
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                closeButtonHtml: ReactDOMServer.renderToString(
                    <a href={properties.REDIRECT_LOGIN}>
                        <CloseIcon />
                    </a>
                ),
            });
        } else {
            if (resjs?.response && !resjs.response.error) {
                if (apptoken) {
                    const loyalty = await fetch(
                        `${process.env.NEXT_PUBLIC_FE_EMAIL}` +
                        `${resjs.response.email}`
                    );
                    const loyaltyJS = await loyalty.json()
                    if (!loyaltyJS.response.programKeys) {
                        Swal.fire({
                            title: properties.MESSAGE_BA_LOYALTY_KO,
                            showCloseButton: true,
                            showCancelButton: false,
                            showConfirmButton: false,
                            closeButtonHtml: ReactDOMServer.renderToString(
                                <a href={properties.REDIRECT_LOGIN}>
                                    <CloseIcon />
                                </a>
                            ),
                        });
                    }
                }
                const data = resjs.response;
                setFormData({
                    name: data.first_name,
                    lastname: data.last_name,
                    email: data.email,
                    customer_title: data.title,
                });
            } else {
                Swal.fire({
                    title: resjs.response.error_description,
                    showCloseButton: true,
                    showCancelButton: false,
                    showConfirmButton: false,
                    closeButtonHtml: ReactDOMServer.renderToString(
                        <a href={properties.REDIRECT_LOGIN}>
                            <CloseIcon />
                        </a>
                    ),
                });
            }
        }
    };

    useEffect(() => {

        if (language) {
            setErrorLanguage(false)
        }
        if (type) {
            setErrorType(false)
        }
        if (contact) {
            setErrorContact(false)
        }
        if (phone) {
            setErrorPhone(false)
        }
    }, [language, type, contact, phone])

    const nextStep = () => {
        if (step === 0) {
            if (!bookingTime) {
                setErrorTimeCheck(true)
            } else {
                setErrorTimeCheck(false)
                setStep(1)
                setStepTitle(dataContent.step2.title)
            }

        }
        if (step === 1) {
            if (!language) {
                setErrorLanguage(true)
            }
            if (!type) {
                setErrorType(true)
            }
            if (!contact) {
                setErrorContact(true)
            }
            if (!phone) {
                setErrorPhone(true)
            }
            else if (language && type && contact && phone) {
                setStep(2)
                setStepTitle(dataContent.step3.title)
            }
        }
        if (step === 2) {

        }
    }

    const prevStep = (currentStep) => {
        if (currentStep === 2) {
            setStepTitle('Appointment datails')
            setLanguage('')
            setType('')
            setContact('')
            setPhone('')
        }
        if (currentStep === 1) {
            setStepTitle('Calendar')
        }
        setStep(currentStep - 1)

    }

    const openBooking = () => {
        setOpenedBooking(true)
        localStorage.setItem('BOOKING', JSON.stringify(true));
    }

    const closeBooking = () => {
        setOpenedBooking(false)
        JSON.stringify(localStorage.removeItem('BOOKING'))
        router.reload()

    }

    const title = dataContent.brand.title;
    const text = dataContent.brand.text;
    const textLoggedIn = dataContent.brand.text_logged;
    const ctaTitle = dataContent.brand.cta_title;

    return (
        <div className={styles.container}>
            <div className={`${styles.header} ${!openBooking ? styles.col : ''}`}>
                <div>
                    
                    <div className={styles.textSection}>
                        <p>
                            {title}
                        </p>
                        <div className={styles.flex}>
                            <div dangerouslySetInnerHTML={{ __html: (app || checkCookies("myarea")) ? textLoggedIn : text }}>
                            </div>
                            {!openedBooking &&
                                <span className={styles.book}>
                                    <a onClick={() => openBooking()}> {ctaTitle}</a>
                                </span>
                            }
                        </div>

                    </div>
                </div>
                {openedBooking && !app && !checkCookies("myarea") && 
                    <div>
                        <button className={styles.closeIcon} onClick={() => closeBooking()}>
                            {React.createElement(SvgClose)}
                        </button>
                    </div>
                }
            </div>
            {openedBooking ?
                apptoken ?
                    (
                        <>
                            <div className={styles.main}>
                                <div className={styles.pageCounter}>
                                    {!booked &&
                                        <>
                                            <p><span>0{step + 1}</span>/03</p>
                                            <p>{stepTitle}</p>
                                        </>
                                    }
                                </div>
                                {step === 0 &&
                                    <Calendar
                                        dataContent={dataContent.step1}
                                        disableDate={disableDate}
                                        control={control}
                                        date={date}
                                        setDate={setDate}
                                        bookingTime={bookingTime}
                                        setBookingTime={setBookingTime}
                                        bookingDays={bookingDays}
                                        errorTimeCheck={errorTimeCheck}
                                        dataLang={dataLang}
                                        slotLen={slotLen}
                                    />}
                                {step === 1 &&
                                    <div className={styles.myInformationBooking}>

                                        <MyInformationBooking
                                            dataContent={dataContent.step2}
                                            formData={formData}
                                            register={register}
                                            setPhone={setPhone}
                                            setCategories={setCategories}
                                            setContact={setContact}
                                            setLanguage={setLanguage}
                                            setType={setType}
                                            bookableBrand={bookableBrand}
                                            brandId={brandId}
                                            setMessage={setMessage}
                                            errorLanguage={errorLanguage}
                                            errorType={errorType}
                                            errorPhone={errorPhone}
                                            errorContact={errorContact}
                                            lang={optionLang}
                                        />
                                    </div>
                                }
                                {step === 2 &&

                                    <ConfirmationBooking
                                        dataLang={dataLang}
                                        dataContent={dataContent}
                                        contact={contact}
                                        phone={phone}
                                        date={date}
                                        bookingTime={bookingTime}
                                        booked={booked}
                                        formData={formData}
                                        setBooked={setBooked}
                                        brandName={brandName}
                                        message={message}
                                        type={type}
                                        language={language}
                                        categories={categories}
                                        brandId={brandId}
                                    />
                                }
                            </div>
                            <div className={`${styles.footer} ${step > 0 ? styles.justBeetw : ''}`}>
                                {step > 0 && !booked &&
                                    <ButtonWithIcon
                                        empty
                                        onClick={() => prevStep(step)}
                                        link={{ title: dataContent.step2.cta_title_previous }}
                                        leftArrow
                                    />
                                }
                                {step !== 2 &&
                                    <ButtonWithIcon onClick={() => nextStep()} link={{ title: dataContent.step2.cta_title_next }} showArrow />
                                }
                            </div>
                        </>
                    )
                    :
                    (!checkCookies("myarea")) ?
                        <AccessForm properties={properties} loginData={dataContent.login} />
                        :
                        loyaltyCookie === false ?
                            <AcceptLoyalty dataContent={dataContent.loyalty} properties={properties} setLoyalty={setLoyalty} />
                            :
                            <>
                                <div className={styles.main}>
                                    <div className={styles.pageCounter}>
                                        {!booked &&
                                            <>
                                                <p><span>0{step + 1}</span>/03</p>
                                                <p>{stepTitle}</p>
                                            </>
                                        }
                                    </div>
                                    {step === 0 &&
                                        <Calendar
                                            dataContent={dataContent.step1}
                                            disableDate={disableDate}
                                            control={control}
                                            date={date}
                                            setDate={setDate}
                                            bookingTime={bookingTime}
                                            setBookingTime={setBookingTime}
                                            bookingDays={bookingDays}
                                            errorTimeCheck={errorTimeCheck}
                                            dataLang={dataLang}
                                            slotLen={slotLen}
                                        />}
                                    {step === 1 &&
                                        <div className={styles.myInformationBooking}>

                                            <MyInformationBooking
                                                dataContent={dataContent.step2}
                                                formData={formData}
                                                register={register}
                                                setPhone={setPhone}
                                                setCategories={setCategories}
                                                setContact={setContact}
                                                setLanguage={setLanguage}
                                                setType={setType}
                                                bookableBrand={bookableBrand}
                                                brandId={brandId}
                                                setMessage={setMessage}
                                                errorLanguage={errorLanguage}
                                                errorType={errorType}
                                                errorPhone={errorPhone}
                                                errorContact={errorContact}
                                                lang={optionLang}
                                            />
                                        </div>
                                    }
                                    {step === 2 &&

                                        <ConfirmationBooking
                                            dataLang={dataLang}
                                            dataContent={dataContent}
                                            contact={contact}
                                            phone={phone}
                                            date={date}
                                            bookingTime={bookingTime}
                                            booked={booked}
                                            formData={formData}
                                            setBooked={setBooked}
                                            brandName={brandName}
                                            message={message}
                                            type={type}
                                            language={language}
                                            categories={categories}
                                            brandId={brandId}
                                        />
                                    }
                                </div>
                                <div className={`${styles.footer} ${step > 0 ? styles.justBeetw : ''}`}>
                                    {step > 0 && !booked &&
                                        <ButtonWithIcon
                                            empty
                                            onClick={() => prevStep(step)}
                                            link={{ title: dataContent.step2.cta_title_previous }}
                                            
                                        />
                                    }
                                    {step !== 2 &&
                                        <ButtonWithIcon onClick={() => nextStep()} link={{ title: dataContent.step2.cta_title_next }}  />
                                    }
                                </div>
                            </>
                :
                <div></div>
            }
        </div>
    )
}




export default BookingForm;